import jQuery from 'jquery';

jQuery(function($) {
  // выход из функции на маленьких мониторах
  if (window.innerWidth < global.width_md) {
    return;
  }

  const $floats = $('.float');

  $floats.each(function() {
    const $float = $(this);
    const minWidthBreakpoint = $float.data('breakpoint') ? ('width_' + $float.data('breakpoint')) : 'width_md';

    if (window.innerWidth < global[minWidthBreakpoint]) {
      $float.css({ 'position': 'relative' });

      return;
    }

    const $parent = $(this).parent();
    $parent.css({ 'position': 'relative' });

    const $track = $($float.data('trackSelector'));

    let trackChildHeight = 0;

    $track.children().each(function() {
      trackChildHeight += $(this).outerHeight(true);
    });

    $track.css({ 'min-height': trackChildHeight });
    $track.data('min-height', trackChildHeight);

    // убираем position: absolute и завершаем скрипт если плавающий блок больше трека, кроме плавающего блока с
    // первого экрана
    if (trackChildHeight > $track.height() && $float.closest('.section--first-screen').length === 0) {
      $float.removeClass('float');
      return;
    }

    // запоминаем начальную позицию относительно окна и родителя для ограничения движения сверху
    const floatInitialTop = Math.round($float.offset().top);
    const floatInitialTopFromParent = ($float.css('top'));

    $(window).on('scroll', function() {
      // текущая позиция окна
      const currentTop = Math.round($(this).scrollTop());

      // координаты конца трека
      const trackBottom = Math.round($track.offset().top + $track.outerHeight(true));

      // дополнительные параметры для вычислений
      const parentTop = Math.round($parent.offset().top);
      const floatHeight = Math.round($float.height());

      // отступ сверху, учитывая плавающий хэдер
      const topOffset = $('.header__bottom').height() + 10;

      let CSS = {};

      if (currentTop > floatInitialTop - topOffset) {
        CSS = {
          'top': topOffset,
          'position': 'fixed',
        };
        if ($float.width() > 0) {
          CSS['width'] = $float.width();
        }
      } else {
        CSS = {
          'top': floatInitialTopFromParent,
          'position': 'absolute',
        };
      }

      if (currentTop > trackBottom - floatHeight - topOffset) {
        CSS = {
          'top': (trackBottom - floatHeight - parentTop) + 'px',
          'position': 'absolute',
        };
      }

      $float.css(CSS);
    });
  });

  $(window).trigger('scroll');
});
